import { useContext } from 'react'
import UserIcon from '@BUP/assets/Images/Data/students_icon.svg'
import { useTranslation } from 'react-i18next'
import styles from './sociogram-ece-page.module.scss'
import PageLayout from '@BUP/components/Layout/Page'
import TitleDashboard from '@BUP/components/Generics/TitleDashboard'
import CollapseInfoSociogram from '@BUP/components/Generics/CollapsePanel/CollapseInfoSociogram'
import SociogramContentSwitcher from '@BUP/components/Sociogram/sociogram-content-switcher'
import SociogramProviders from '@BUP/components/Sociogram/SociogramProviders'
import { CurrentTermContext } from '@BUP/contexts/CurrentTermContext'

const SociogramECEPage = () => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.sociogram.activeSociogramEce'
  })
  const term = useContext(CurrentTermContext)

  return (
    <PageLayout>
      <div className={styles.container}>
        <TitleDashboard
          icon={UserIcon}
          text={t('title')}
        />
        <p className={styles.welcome_text}>{t('intro')}</p>
        <CollapseInfoSociogram />
        <SociogramProviders termId={term.id}>
          <SociogramContentSwitcher />
        </SociogramProviders>
      </div>
    </PageLayout>
  )
}

export default SociogramECEPage
